import { GetStaticPaths, GetStaticProps } from 'next'
import { Container } from '@/components/shared/Container'
import { SubNavigation } from '@/elements/global/SubNavigation'
import { ArticlesByCategory } from '@/components/pages/learn/Article/ArticlesByCategory'
import {
  getTopAcademyCategories,
  getCategoryBySlug,
  latestArticlesByCategory,
  getSubCategoriesByID,
} from '@/graphql/HealthAcademyCategories'
import styled from 'styled-components'
import { Footer } from '@/components/elements/new-footer/Footer'
import { Header } from '@/components/elements/header/Header'
import { theme } from 'styles/theme'
import { SEOMetaTags } from '@/components/shared/SEOMetaTags'

type CategoryContentProps = {
  categories?: any
  category?: any
  params?: any
  articlesByCategory?: any
  subcategories?: any
}

const StyledIntro = styled.div`
  text-align: center;
  margin: 80px 0;
  h1 {
    font-family: ${(props) => props.theme.v2.font.nantes};
  }
  @media screen and (max-width: ${(props) => props.theme.breakpoints.mobile}) {
    margin: 40px 0 60px;
  }
`

export const Index = ({ categories, category, articlesByCategory, subcategories, params }: CategoryContentProps) => {
  const { categoryName, categorySlug, description, metadata } = category

  return (
    <>
      <SEOMetaTags metaData={metadata} path={`/category/${categorySlug}`} />
      <Header backgroundColor={theme.v2.surface.white} />
      <SubNavigation title="Learn" categories={categories} selected={params.slug} />
      <main id="main-content">
        <StyledIntro>
          <Container>
            <h1>{categoryName}</h1>
            <p>{description}</p>
          </Container>
        </StyledIntro>
        {subcategories.map((subcategory, categoryIndex) => {
          const articles = articlesByCategory[categoryIndex]
          return (
            <ArticlesByCategory
              key={subcategory.id}
              categoryID={subcategory.id}
              categoryName={subcategory.categoryName}
              categorySlug={categorySlug}
              subCategorySlug={subcategory.categorySlug}
              articles={articles}
              showHeader={true}
            />
          )
        })}
      </main>
      <Footer showPreFooter />
    </>
  )
}

export const getStaticPaths: GetStaticPaths = async () => {
  const categories = await getTopAcademyCategories()
  const categoryPaths = categories.map((category) => `/learn/category/${category.categorySlug}`)
  const paths = categoryPaths

  return { paths, fallback: false }
}

export const getStaticProps: GetStaticProps = async ({ params, preview }) => {
  const categories = await getTopAcademyCategories()
  const category = await getCategoryBySlug(params?.slug, preview)
  const subcategories = await getSubCategoriesByID(category.id, preview)
  const promiseArray = subcategories.map((subcategory) => latestArticlesByCategory(subcategory.id))
  const articlesByCategory = await Promise.all(promiseArray).then((values) => values)
  return { props: { categories, category, articlesByCategory, subcategories, params } }
}

export default Index
